import { createContext } from "react"
import { TextoModel } from "../models/textoModel"
import { TextoImpressaoActionModel } from "./textoImpressaoActions"
import { TextoImpressaoInicial } from "./textoImpressaoInicial"

type textoImpressaoContextProps = {
    textoImpressao: TextoModel
    dispatchTexoImpressao: React.Dispatch<TextoImpressaoActionModel>
    salvarConfiguracoes: () => Promise<void>
    carregando: boolean
}

const initialContextValue: textoImpressaoContextProps = {
    textoImpressao: TextoImpressaoInicial,
    dispatchTexoImpressao: () => {},
    salvarConfiguracoes: async () => {},
    carregando: false,
}

export const TextoImpressaoContext = createContext<textoImpressaoContextProps>(initialContextValue)
